import {useState} from 'react';
import HeaderPage from '../../components/header_page';
import {useParams} from 'react-router-dom';

import Choose from './choose';
import Provider from './provider';

export default () => {
    const {token} = useParams(),
          [provider, setProvider] = useState(null);

    const [token_symbol, token_network] = (token || "").split('_');

    return (
        <>
            {!provider ? (
                <>
                    <HeaderPage title={`${token_symbol}${token_network ? ` (${token_network === 'ERC20' ? 'ERC-20' : 'TRC-20'})` : ''}`} />
                    <Choose onNext={provider => setProvider(provider)} />
                </>
            ) : <Provider token={token} token_symbol={token_symbol} token_network={token_symbol === "ETH" ? "ERC20" : token_network} provider={provider} setProvider={setProvider} />}
        </>
    )
}